export default __webpack_public_path__ + "static/media/1809.8e0d23eb.png";